$(document).ready(function () {
  /**
   * START - Modal section
   */
  // function phoneVerificationModal() {
  //     const modal = $('#phoneVerificationModal');
  //
  //     $('.js-phone-verification-modal').click(function (e) {
  //         e.preventDefault();
  //         modal.modal({});
  //     });
  //
  //     modal.find('.js-modal-next').click(function (e) {
  //         e.preventDefault();
  //         modal.find(".js-modal-messages").html('');
  //         modal.find('#form-step1').submit();
  //     });
  //
  //     modal.find('.js-modal-verify').click(function (e) {
  //         e.preventDefault();
  //         modal.find(".js-modal-messages").html('');
  //         modal.find('#form-step2').submit();
  //     });
  //
  //     modal.find('#form-step1').on('submit', function (e) {
  //         e.preventDefault();
  //
  //         if (!this.checkValidity()) {
  //             return;
  //         }
  //
  //         const phonePrefix = modal.find('#phone_prefix').val();
  //         const phone = modal.find('#phone').val();
  //
  //         $.post(zRoute('ajax.verification.phone.send_code'), {
  //             'phone': phonePrefix + " " + phone
  //         }, function (data) {
  //             modal.find(".js-modal-messages").html(data.message);
  //             modal.find('.modal-steps').hide();
  //             modal.find('.modal-step2').show();
  //         }).done(function () {
  //         }).fail(function (data) {
  //             modal.find(".js-modal-messages").html(window.errorsToHtml(data.responseJSON));
  //         });
  //     });
  //
  //     modal.find('#form-step2').on('submit', function (e) {
  //         e.preventDefault();
  //
  //         if (!this.checkValidity()) {
  //             return;
  //         }
  //
  //         const phoneVerificationCode = modal.find('#phone_verification_code').val();
  //         const phonePrefix = modal.find('#phone_prefix').val();
  //         const phone = modal.find('#phone').val();
  //
  //         $.post(zRoute('ajax.verification.phone.check_code'), {
  //             'phone_verification_code': phoneVerificationCode,
  //             'phone': phonePrefix + " " + phone,
  //         }, function (data) {
  //             modal.find(".js-modal-messages").html(data.message);
  //
  //             setTimeout(function () {
  //                 window.location.reload(true);
  //             }, 1000)
  //
  //         }).done(function () {
  //         }).fail(function (data) {
  //             modal.find(".js-modal-messages").html(window.errorsToHtml(data.responseJSON));
  //         });
  //     });
  //
  //     modal.find('.js-modal-back').click(function (e) {
  //         e.preventDefault();
  //         modal.find('.modal-steps').hide();
  //         modal.find('.modal-step1').show();
  //     });
  // }
  //
  // if (document.getElementById('phoneVerificationModal')) {
  //     phoneVerificationModal();
  // }
  //
  // function emailVerificationModal() {
  //     const modal = $('#emailVerificationModal');
  //
  //     $('.js-email-verification-modal').click(function (e) {
  //         e.preventDefault();
  //         modal.modal({});
  //     });
  //
  //     modal.find('.js-modal-verify').click(function (e) {
  //         e.preventDefault();
  //         modal.find(".js-modal-messages").html('');
  //         modal.find('form').submit();
  //     });
  //
  //     modal.find('form').on('submit', function (e) {
  //         e.preventDefault();
  //
  //         if (!this.checkValidity()) {
  //             return;
  //         }
  //
  //         const email = modal.find('#email').val();
  //
  //         $.post(zRoute('ajax.verification.email.send'), {
  //             'email': email,
  //         }, function (data) {
  //             modal.find(".js-modal-messages").html(data.message);
  //
  //             setTimeout(function () {
  //                 window.location.reload(true);
  //             }, 1000)
  //
  //         }).done(function () {
  //         }).fail(function (data) {
  //             modal.find(".js-modal-messages").html(window.errorsToHtml(data.responseJSON));
  //         });
  //     });
  // }
  //
  // if (document.getElementById('emailVerificationModal')) {
  //     emailVerificationModal();
  // }

  // function imageEditModal() {
  //     const imageEditModal = $('#imageEditModal');
  //     const avatarCheckbox = imageEditModal.find('#avatar');
  //     const paidCheckbox = imageEditModal.find('#paid');
  //     const priceInput = imageEditModal.find('#price');
  //     const editForm = imageEditModal.find('form#form-edit');
  //
  //     $('.js-image-edit-modal').click(function () {
  //         const modal = imageEditModal;
  //         const imageUrl = $(this).data('image');
  //         const url = $(this).data('url');
  //         const urlDelete = $(this).data('delete-url');
  //         const price = $(this).data('price');
  //         const canEdit = $(this).data('can-edit');
  //
  //         if (canEdit === false) {
  //             modal.find('.js-editable').hide();
  //         } else {
  //             modal.find('.js-editable').show();
  //         }
  //
  //         avatarCheckbox.prop('checked', false);
  //         if (price) {
  //             paidCheckbox.prop('checked', true).change();
  //             priceInput.val(price);
  //         } else {
  //             paidCheckbox.prop('checked', false).change();
  //             priceInput.val(20);
  //         }
  //
  //         modal.find('.js-image-preview').css("background-image", `url('${imageUrl}')`);
  //         modal.find('form#form-edit').attr("action", url);
  //         modal.find('form#form-delete').attr("action", urlDelete);
  //         modal.modal({});
  //     });
  //
  //     avatarCheckbox.change(function () {
  //         if (this.checked) {
  //             paidCheckbox.prop('checked', false);
  //             paidCheckbox.prop("disabled", true);
  //             priceInput.prop("disabled", true);
  //             priceInput.val('');
  //
  //             setTimeout(function () {
  //                 editForm.submit();
  //             }, 100);
  //         } else {
  //             paidCheckbox.prop("disabled", false);
  //             priceInput.prop("disabled", false);
  //         }
  //
  //     });
  //     paidCheckbox.change(function () {
  //         if (this.checked) {
  //             priceInput.prop("disabled", false);
  //         } else {
  //             priceInput.prop("disabled", true);
  //             priceInput.val('');
  //         }
  //     });
  // }
  //
  // if (document.getElementById('imageEditModal')) {
  //     imageEditModal();
  // }

  // function imageAddModal() {
  //     const imageAddModal = $('#imageAddModal');
  //     const fileInput = $('#imageAddModal').find('input[type="file"]');
  //
  //     fileInput.on('change', function () {
  //         let self = $(this);
  //         let file = this.files[0];
  //
  //         if ((file.size / 1024) > self.data('max-file-size')) {
  //             new Noty({
  //                 theme: 'metroui',
  //                 type: 'error',
  //                 text: self.data('max-file-message'),
  //             }).show();
  //         } else {
  //             imageAddModal.modal({});
  //         }
  //     })
  //
  //     $('.js-image-add-modal').click(function () {
  //         fileInput.click();
  //     });
  // }
  //
  // if (document.getElementById('imageAddModal')) {
  //     imageAddModal();
  // }
  /**
   * STOP - Modal section
   */

  /**
   * START - PROFILE Image Add
   */
  // const cropper = {
  //     selectors: {
  //         imageInput: 'image-input',
  //         imageError: 'image-error',
  //     },
  //     elements: {
  //         modal: $('#imageAddModal'),
  //         imageInput: $('input#image-input'),
  //         cropperImage: $('img#image-cropper-img'),
  //         cropperSaveButton: $('button#image-cropper-save-btn'),
  //         cropperZoomInButton: $('button#zoom-in-btn'),
  //         form: $('button#image-cropper-save-btn').closest('form'),
  //         imageInputData: $('input#image-cropped-data'),
  //         zoomSlider: $('#js-zoom-slider'),
  //         cropper: null,
  //     },
  //     init: function () {
  //         const self = this;
  //
  //         const image = self.elements.cropperImage[0];
  //         if (image)
  //             image.addEventListener('ready', () => self.initSlider());
  //
  //         this.elements.modal.on('shown.bs.modal', function (e) {
  //             self.elements.modal.find("." + self.selectors.imageError).html('');
  //             self.setImageCropper();
  //         });
  //         this.elements.modal.on('hide.bs.modal', function (e) {
  //             self.elements.modal.find("." + self.selectors.imageError).html('');
  //             self.elements.cropperImage.attr('src', '');
  //             self.elements.imageInput.val('');
  //         });
  //
  //         // self.elements.cropperSaveButton.click(function (e) {
  //         //     e.preventDefault();
  //         //     self.onSaveButton();
  //         // });
  //     },
  //     loadImagePreview: function (image) {
  //         let reader = new FileReader();
  //         var self = this;
  //
  //         let promise = new Promise((resolve, reject) => {
  //             reader.onload = function (e) {
  //                 self.elements.cropperImage.attr('src', e.target.result);
  //                 resolve();
  //             };
  //         });
  //
  //         reader.readAsDataURL(image);
  //         return promise;
  //     },
  //
  //     isImageFile: function (file) {
  //         if (file.type) {
  //             return /^image\/\w+$/.test(file.type);
  //         } else {
  //             return /\.(jpe?g|png|gif)$/i.test(file);
  //         }
  //     },
  //     initSlider: function (zoom = 0) {
  //         const self = this;
  //         self.elements.zoomSlider.on('input', function (event) {
  //             const zoomValue = event.target.value;
  //             self.elements.cropper.zoomTo(zoomValue);
  //         });
  //     },
  //     setImageCropper: function () {
  //         const self = this;
  //         const e = document.getElementById(self.selectors.imageInput);
  //
  //         if (self.elements.cropper) {
  //             self.elements.cropper.destroy();
  //             self.elements.cropper = null;
  //         }
  //
  //         let errorMessage = '',
  //             file = null;
  //         if (e.files && (file = e.files[0])) {
  //             if (self.isImageFile(file)) {
  //                 self.loadImagePreview(e.files[0]).then(() => {
  //                     const image = self.elements.cropperImage[0];
  //                     self.elements.cropper = new Cropper(image, {
  //                        // aspectRatio: 1.5 / 2,
  //                         aspectRatio: 580 / 800,
  //                         viewMode: 3,
  //                         guides: false,
  //                         center: false,
  //                         background: false,
  //                         movable: true,
  //                         cropBoxMovable: false,
  //                         //  minCropBoxWidth: 1,
  //                         preview: ".crop_preview",
  //                         autoCropArea: 1,
  //                         scalable: true,
  //                         dragMode: 'move',
  //                         ready() {
  //                             const minZoom = this.cropper.canvasData.width / this.cropper.canvasData.naturalWidth;
  //
  //                             self.elements.zoomSlider.attr('min', minZoom);
  //                             self.elements.zoomSlider.val(minZoom);
  //                             this.cropper.zoomTo(minZoom);
  //                         },
  //                     });
  //                 });
  //             } else {
  //                 self.elements.cropperImage.attr('src', '');
  //                 let avatarError = self.elements.imageInput.next(self.selectors.imageError);
  //                 errorMessage = 'Foto nur im JPG-, JPEG-, PNG- oder GIF-Format';
  //                 if (avatarError.length) {
  //                     avatarError.text(errorMessage);
  //                 } else {
  //                     self.elements.imageInput.after('<span class="invalid-feedback d-block image-error" role="alert"><strong>' + errorMessage + '</strong></span>');
  //                 }
  //             }
  //         }
  //     },
  //     onSaveButton: function () {
  //         var self = this;
  //
  //         const cropperCanvas = self.elements.cropper.getCroppedCanvas({
  //                 width: 580,
  //                 height: 800
  //             }),
  //             cropperData = self.elements.cropper.getData(true);
  //
  //         cropperCanvas.toBlob(function (blob) {
  //             let croppedImage = document.createElement('img'),
  //                 url = URL.createObjectURL(blob);
  //             croppedImage.onload = function () {
  //                 // no longer need to read the blob so it's revoked
  //                 URL.revokeObjectURL(url);
  //             };
  //
  //             //  self.elements.cropper.imagePreview.attr('src', url);
  //             self.elements.imageInputData.val(JSON.stringify(cropperData));
  //             self.elements.form.submit();
  //         }, 'image/png', 0.95); // PNG at 95% quality
  //     },
  // };

  //  cropper.init();
  /**
   * STOP - PROFILE Image Add
   */
});
